export const ChecklistIcon: React.FC<{ color: string }> = (props: { color: string }) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            data-testid="checklist-icon-wrapper"
        >
            <rect width="11" height="12.4444" rx="0.888889" fill={props.color} />
            <path d="M1.57129 2.66699H9.42843" stroke="white" strokeWidth="0.888889" />
            <path d="M1.57129 4.44434H9.42843" stroke="white" strokeWidth="0.888889" />
            <path d="M1.57129 6.22266H4.71415" stroke="white" strokeWidth="0.888889" />
            <rect x="6.25" y="6.25" width="9.5" height="9.5" rx="1.75" fill="white" />
            <rect
                x="6.25"
                y="6.25"
                width="9.5"
                height="9.5"
                rx="1.75"
                stroke={props.color}
                strokeWidth="0.5"
            />
            <rect x="7" y="7" width="8" height="8" rx="2" fill="white" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.75 10.666C7.75 10.5279 7.86193 10.416 8 10.416H10.3333C10.4714 10.416 10.5833 10.5279 10.5833 10.666C10.5833 10.8041 10.4714 10.916 10.3333 10.916H8C7.86193 10.916 7.75 10.8041 7.75 10.666Z"
                fill={props.color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.75 12.334C7.75 12.1959 7.86193 12.084 8 12.084H10.3333C10.4714 12.084 10.5833 12.1959 10.5833 12.334C10.5833 12.4721 10.4714 12.584 10.3333 12.584H8C7.86193 12.584 7.75 12.4721 7.75 12.334Z"
                fill={props.color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.8208 10.4689C13.9296 10.5538 13.949 10.7109 13.8641 10.8198L12.5641 12.4865C12.5177 12.5459 12.447 12.5813 12.3715 12.5827C12.2961 12.584 12.2241 12.5513 12.1756 12.4935L11.4756 11.6602C11.3868 11.5544 11.4005 11.3967 11.5062 11.3079C11.6119 11.2191 11.7696 11.2328 11.8584 11.3386L12.3598 11.9354L13.4699 10.5123C13.5548 10.4034 13.7119 10.384 13.8208 10.4689Z"
                fill={props.color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.75 9C7.75 8.86193 7.86193 8.75 8 8.75H11.5C11.6381 8.75 11.75 8.86193 11.75 9C11.75 9.13807 11.6381 9.25 11.5 9.25H8C7.86193 9.25 7.75 9.13807 7.75 9ZM12.6667 9C12.6667 8.86193 12.7786 8.75 12.9167 8.75H13.6667C13.8047 8.75 13.9167 8.86193 13.9167 9C13.9167 9.13807 13.8047 9.25 13.6667 9.25H12.9167C12.7786 9.25 12.6667 9.13807 12.6667 9Z"
                fill={props.color}
            />
        </svg>
    )
}
